import { apiV2 } from './api';

/** Default der BK-Pause nach einer Betreuung (Tage) — wie im Backend. */
export const BK_PAUSE_DAYS_DEFAULT = 21;

/**
 * Admin-Setting `bk_pause_days` (Einstellungen → BK Stages): Pause einer BK
 * in Tagen nach einer Betreuung mit autobreak, Bereich 0..365, Default 21.
 * Ausgewertet vom CareStateWorker (Status „Pausierend", „Verfügbar ab").
 * PUT schickt nur diesen Key — das Backend validiert alle Keys mit
 * 'sometimes', andere Einstellungen bleiben unverändert.
 */
export const bkPauseDaysApi = {
  get: async (): Promise<number> => {
    const res = await apiV2.get<{ data: { bk_pause_days?: number } }>('/admin/system-settings');
    return res.data.data.bk_pause_days ?? BK_PAUSE_DAYS_DEFAULT;
  },

  update: async (value: number): Promise<number> => {
    const res = await apiV2.put<{ data: { bk_pause_days: number } }>(
      '/admin/system-settings',
      { bk_pause_days: value },
    );
    return res.data.data.bk_pause_days;
  },
};
